import { v4 as uuidv4 } from "uuid";
import { createContext, useContext, useState } from "react";

import { Drawer } from "./component";
import { DrawerListProps, DrawerProps, DrawerProviderProps } from "./types";

interface DrawerContextProps {
  addDrawer: (alertProps: DrawerProps) => void;
}

const DrawerContext = createContext<DrawerContextProps>({
  addDrawer: () => {},
});

export const DrawerProvider = ({ children }: DrawerProviderProps) => {
  const [drawers, setDrawers] = useState<DrawerListProps[]>([]);

  const addDrawer = (drawerProps: DrawerProps) => {
    const id = uuidv4();

    setDrawers((state) => {
      return [
        ...state,
        {
          ...drawerProps,
          id,
          onClose: () => onClose(id),
          open: "opening",
        },
      ];
    });

    setTimeout(() => {
      setDrawers((state) => {
        return state.map((state) => {
          if (state.id === id) {
            return {
              ...state,
              open: "open",
            };
          } else {
            return state;
          }
        });
      });
    }, 100);
  };

  const onClose = (id?: string) => {
    if (id) {
      _endDrawer(id);
    }
  };

  const _endDrawer = (id: string) => {
    setDrawers((state) => {
      return state.map((state) => {
        if (state.id === id) {
          return (state = {
            ...state,
            open: "closing",
          });
        } else {
          return state;
        }
      });
    });

    setTimeout(() => {
      setDrawers((state) => {
        return state.map((state) => {
          if (state.id === id) {
            return {
              ...state,
              open: "close",
            };
          } else {
            return state;
          }
        });
      });
    }, 100);

    setTimeout(() => {
      setDrawers((state) => {
        return state.map((state) => {
          if (state.id === id) {
            return {
              ...state,
              open: "close-full",
            };
          } else {
            return state;
          }
        });
      });
    }, 700);

    setTimeout(() => {
      setDrawers((state) => {
        return state.filter((state) => state.id !== id);
      });
    }, 800);
  };

  return (
    <DrawerContext.Provider
      value={{
        addDrawer,
      }}
    >
      <>
        {children}
        {drawers.map((alert, index) => {
          return <Drawer key={index} {...alert} />;
        })}
      </>
    </DrawerContext.Provider>
  );
};

export const useDrawerListener = () => {
  return useContext(DrawerContext);
};
